// "Who is coming to what" is not one list but several.
//
// A guest belongs to exactly ONE set: the functions they are invited to. For
// "Sahil weds Diksha" that gives the Reception-only list, the Thread Ceremony +
// Reception list, the everything list, and so on — each one a sheet to print
// and hand to whoever is working that function.
//
// Pure, so it can be tested without a browser; useMembers feeds it the guest
// rows (already grouped one-per-person) and the functions still to come.

// → [{ key, ids, label, count, rows, guests, persons }], biggest list first.
export function buildFunctionSets(people, openFunctions, idsOf) {
  const order = new Map((openFunctions || []).map((f, i) => [String(f.FunctionId), i]));
  const nameOf = new Map((openFunctions || []).map(f => [String(f.FunctionId), f.FunctionName]));
  const sets = new Map();

  (people || []).forEach(person => {
    const ids = [...new Set((idsOf(person) || []).map(String))]
      .filter(id => order.has(id))                 // a function that is over is not a list
      .sort((a, b) => order.get(a) - order.get(b));  // the order the event runs in
    if (!ids.length) return;
    const key = ids.join(',');
    if (!sets.has(key)) {
      sets.set(key, {
        key,
        ids,
        // "Reception" alone would read as "everyone coming to the Reception",
        // which is a different (larger) list - these sets are EXACT.
        label: ids.map(id => nameOf.get(id)).join(' + ') + (ids.length === 1 ? ' only' : ''),
        count: ids.length,
        rows: [],
        guests: 0,
        persons: 0,
      });
    }
    const set = sets.get(key);
    set.rows.push(person);
    set.guests += 1;
    set.persons += Math.max(1, Number(person.ExpectedCount || 1));
  });

  return [...sets.values()].sort((a, b) => b.guests - a.guests
    || a.count - b.count
    || order.get(a.ids[0]) - order.get(b.ids[0]));
}
